module.exports = {
    appName: 'My neat app',
    days: 0
  };